import { build_query_string } from '/srv/web/wyvr/html/releases/58819/gen/client/checkout/helper.js?1733898722546';
import is_logged_in from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/is_logged_in.js?1733898722546';
import { checkout_data } from '/srv/web/wyvr/html/releases/58819/gen/client/checkout/stores/checkout_data.js?1733898722546';
import { checkout_entrance_mapping } from '/srv/web/wyvr/html/releases/58819/gen/client/checkout/logic/mapping.js?1733898722546';
import { hide_loader, show_loader } from '/srv/web/wyvr/html/releases/58819/gen/client/checkout/logic/loader.js?1733898722546';
import { logger } from '@wyvr/generator/universal.js';

let logged_in = false;
is_logged_in?.subscribe((value) => {
    logged_in = value;
});

let data;
if (true) {
    checkout_data?.subscribe((value) => {
        data = value;
    });
}

/**
 * Allow the visitor to enter the magento checkout by redirecting
 * @param {string} action to tell magento what was requested
 * @returns {void}
 */
export function checkout_entrance(action = '') {
    if (!data) {
        logger.error('checkout not possible');
        return false;
    }
    // action = '' | 'cart';
    // show fullpage loader
    show_loader();
    const domain = getStack('checkout')?.domain ?? '/shop';
    const url = `${domain}/gateway/checkout/entrance${get_query_params(action)}`;
    window.location.href = url;
    return true;
}

/**
 * When a customer logs out the checkout session has to be destroyed
 * @param {string} action
 * @returns
 */
export async function checkout_ending(action = '') {
    if (!logged_in) {
        return;
    }
    return new Promise((resolve) => {
        show_loader();
        const domain = getStack('checkout')?.domain ?? '/shop';
        const url = `${domain}/gateway/checkout/ending${get_query_params(action)}`;
        // create iframe to load the magento checkout ending route
        let ending = document.createElement('iframe');
        ending.setAttribute('id', 'checkout_ending');
        ending.setAttribute('title', 'Logout from shop');
        ending.setAttribute('style', 'position:absolute;bottom:0;right:0;width:1px;height:1px;border:0;opacity:0;');
        document.body.appendChild(ending);
        ending.setAttribute('src', url);
        // timeout guard to avoid total blocked app
        const guard = setTimeout(() => {
            if (ending) {
                // destroy when loaded
                ending.remove();
                ending = null;
                hide_loader();
                resolve();
            }
        }, 10000);
        ending.onload = () => {
            clearTimeout(guard);
            // destroy when loaded
            ending.remove();
            ending = null;
            hide_loader();
            resolve();
        };
    });
}

/**
 * Convert the checkout data to a appendable querystring to append to the entrance/ending gateway of magento
 * @param {string} action
 * @returns
 */
function get_query_params(action) {
    const params_list = [];
    if (typeof data == 'object') {
        Object.entries(data).forEach(([prop, value]) => {
            let key = checkout_entrance_mapping[prop] || prop;
            params_list.push({ key, value });
        });
    }
    if (action) {
        params_list.push({ key: 'action', value: action });
    }
    if (params_list.length == 0) {
        return '';
    }
    return build_query_string(params_list);
}
